// API Configuration
const config = {
  API_BASE_URL: 'https://localhost:7132/',
};

export default config;

